import { render, staticRenderFns } from "./ProductInfoCard.vue?vue&type=template&id=d5d629fa&scoped=true"
import script from "./ProductInfoCard.vue?vue&type=script&lang=js"
export * from "./ProductInfoCard.vue?vue&type=script&lang=js"
import style0 from "./ProductInfoCard.vue?vue&type=style&index=0&id=d5d629fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d629fa",
  null
  
)

export default component.exports